<template>
    <div id="dashboard-date-line-chart" class="echarts"></div>
</template>

<script>
    import * as echarts from 'echarts';
    import { EventBus } from '@/assets/js/event-bus'

    export default {
        name: "LineChart",
        props: {
            data: {},
        },
        watch: {
            data: {
                handler: function(val, oldVal) {
                    this.$nextTick(function() {
                        this.drawChart(val)
                    })
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            drawChart(__data) {
                var chartDom = document.getElementById("dashboard-date-line-chart");
                var myChart = echarts.init(chartDom);
                var option;

                option = {
                    title: {
                        text: '发布报告趋势图',
                        top: 15,
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: 60,
                        right: 30,
                        bottom: 40
                    },
                    xAxis: {
                        type: 'category',
                        data: __data['xData']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: __data['yData'],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    // color: '#8cd5c2', //改变折线点的颜色
                                    lineStyle: {
                                        width: 4,
                                        color: '#67C23A' //改变折线颜色
                                    }
                                }
                            },
                        }
                    ]
                };

                option && myChart.setOption(option);

                window.addEventListener('resize', function() {
                    myChart.resize()
                })
                EventBus.$on('resize', () => {
                    setTimeout(() => {
                        myChart.resize()
                    }, 300) // 折叠动画效果为300ms
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/echarts/LineChart.vue